import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import type { Field } from '../../model/formBuilderInterface';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiCallService } from '../../../../services/api-call.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ValidationErrorsComponent } from '../validation-errors/validation-errors.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { InfoIconComponent } from '@components/info-icon/info-icon.component';
import get from 'lodash/get';
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgSelectModule,
    HttpClientModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    InfoIconComponent
  ]
})
export class FormSelectComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() field: Field;
  @Input() form: FormGroup;
  constructor(
    private readonly apiCallService: ApiCallService,
    private readonly http: HttpClient,
    public readonly cs: CommonService
  ) {}

  ngOnInit() {
    if (this.field.optionsUrl && this.cs.isBrowser) {
      this.fetchAndSetOptions();
    }
  }
  public fetchJSONData(url): Observable<any> {
    return this.http.get(url);
  }
  fetchAndSetJSONOptions() {
    const url = this.field.optionsUrl;
    return this.fetchJSONData(url)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.setOptionsData(data.data || data);
      });
  }
  getNestedValue(obj, path) {
    return get(obj, path)
  }
  setOptionsData(data) {
    if (this.field.placeholderOption) {
      this.field.options = [this.field.placeholderOption, ...data];
    } else {
      this.field.options = data;
    }
    const control = this.form.get(this.field.name);
    if (control) {
      const index = this.field.options.findIndex(
        (item) => item[this.field.valueKey] === control.value
      );
      if (index === -1) {
        control.setValue(null);
      }
    }
  }
  fetchAndSetOptions() {
    const url = this.field.optionsUrl;
    if (url.includes('.json')) {
      this.fetchAndSetJSONOptions();
      return;
    }
    return this.apiCallService
      .get(url, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ data }) => {
        if (this.field.optionListTransformationFn) {
          data = this.field.optionListTransformationFn(data);
        }
        this.setOptionsData(data);
      });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
